import React  from 'react';
import PlaceSelectContainer from '../containers/place_select/PlaceSelectContainer';
import cx from 'classnames';
import {useTranslation} from "react-i18next";
import {Label} from "./form/Layout";
import {
    MapPinIcon,
    HomeIcon,
    CalendarIcon,
    BriefcaseIcon,
} from "@heroicons/react/20/solid";

const StopSelect = ({ id, className, routeId, purpose, expand, firstInput, secondInput}) => {
    const { t } = useTranslation();
    const placeholder = t('shared.enter_step_city_other');
    if (expand) {
        // 2 champs affichés
        return (
            <div className={cx('stop-select space-y-8', className)}>
                <PlaceSelectContainer
                    id={id}
                    filters={{
                        type: 'all',
                        route: routeId,
                        purpose
                    }}
                    onChange={firstInput.onChange}
                    value={firstInput.value}
                    placeholder={placeholder}
                    autoload={null !== firstInput.value}
                    focused={firstInput.focused}
                />
                <div className="subselect">
                    <Label Icon={HomeIcon}>
                        {t('shared.specify_lodging')}
                    </Label>
                    <PlaceSelectContainer
                        filters={{
                            type: 'stop',
                            step: firstInput.value ? firstInput.value.step.id : null,
                            purpose
                        }}
                        onChange={secondInput.onChange}
                        onBlur={secondInput.onBlur}
                        value={secondInput.value}
                        placeholder={t('shared.enter_lodging')}
                        autoload={true}
                        focused={secondInput.focused}
                    />
                </div>
            </div>
        );
    }

    // 1 seul champ - tout confondu
    return (
        <div className={cx('stop-select', className)}>
            <PlaceSelectContainer
                filters={{
                    type: 'all',
                    route: routeId,
                    purpose
                }}
                onChange={firstInput.onChange}
                onBlur={firstInput.onBlur}
                value={firstInput.value}
                placeholder={placeholder}
                autoload={null !== firstInput.value}
                focused={firstInput.focused}
            />
        </div>
    );
};

export default StopSelect;
